import React, { Component } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import LeaderProductionWidget from './../Reports/components/GrowthReportWidget/LeaderWidget.component'
import DownlineGrowthReport from './../Reports/components/GrowthReportWidget/DownlineGrowthReport.component'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'

import './TeamGrowthReportPage.scss'

class TeamGrowthReportPage extends Component {
  render() {
    return (
      <DashboardLayout>
        <main id='TeamGrowthReportPage' className='mainSection pb-5'>
          <MDBContainer fluid className={'mt-5'}>
            <PageHeading
              label={'Team Growth Report'}
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from || '/dashboard'}
            />
            <MDBRow>
              <MDBCol size='12' className='mb-4'>
                <LeaderProductionWidget />
              </MDBCol>
              <MDBCol size='12' className='mt-4'>
                <DownlineGrowthReport />
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default TeamGrowthReportPage
